import * as React from "react";
import { forwardRef } from "react";
const SvgRcArrowBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 48, viewBox: "0 -960 960 960", width: 48, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M400-80 0-480l400-400 56 57-343 343 343 343-56 57Z" }));
const ForwardRef = forwardRef(SvgRcArrowBack);
export { ForwardRef as ReactComponent };
